var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScheduleSend01 = function SvgScheduleSend01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "schedule_send-01_svg2__a",
    x1: -12.21,
    x2: 151.24,
    y1: 160.59,
    y2: -2.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#schedule_send-01_svg2__a",
    id: "schedule_send-01_svg2__b",
    x1: -22.8,
    x2: 140.65,
    y1: 150,
    y2: -13.45
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#schedule_send-01_svg2__a",
    id: "schedule_send-01_svg2__c",
    x1: -0.05,
    x2: 163.4,
    y1: 172.75,
    y2: 9.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#schedule_send-01_svg2__a",
    id: "schedule_send-01_svg2__d",
    x1: 20.08,
    x2: 183.53,
    y1: 192.88,
    y2: 29.43
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#schedule_send-01_svg2__a",
    id: "schedule_send-01_svg2__e",
    x1: 0,
    x2: 163.45,
    y1: 172.8,
    y2: 9.35
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#schedule_send-01_svg2__a",
    id: "schedule_send-01_svg2__f",
    x1: 21.16,
    x2: 184.6,
    y1: 193.96,
    y2: 30.51
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#schedule_send-01_svg2__a",
    id: "schedule_send-01_svg2__g",
    x1: 63.6,
    x2: 227.05,
    y1: 236.4,
    y2: 72.95
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#schedule_send-01_svg2__a",
    id: "schedule_send-01_svg2__h",
    x1: 62.46,
    x2: 225.9,
    y1: 235.26,
    y2: 71.81
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M90.6 168.3v-.1H22.7c-7.5 0-13.6-6.1-13.6-13.6V59.1h150v28.7c0 2.5 2 4.5 4.5 4.5s4.5-2 4.5-4.5V36.3c0-12.5-10.2-22.7-22.7-22.7h-9.1c0-7.5-6.1-13.6-13.6-13.6s-13.6 6.1-13.6 13.6h-50C59.1 6.1 53 0 45.5 0S31.9 6.1 31.9 13.6h-9.1C10.2 13.7 0 23.8 0 36.4v118.2c0 12.5 10.2 22.7 22.7 22.7h67.9c2.5 0 4.5-2 4.5-4.5s-2-4.5-4.5-4.5m27.6-154.7c0-2.5 2-4.5 4.5-4.5s4.5 2 4.5 4.5v9.1c0 2.5-2 4.5-4.5 4.5s-4.5-2-4.5-4.5zm-77.3 0c0-2.5 2-4.5 4.5-4.5s4.5 2 4.5 4.5v9.1c0 2.5-2 4.5-4.5 4.5s-4.5-2-4.5-4.5zM9.1 36.4c0-7.5 6.1-13.6 13.6-13.6h9.1c0 7.5 6.1 13.6 13.6 13.6S59 30.3 59 22.8h50c0 7.5 6.1 13.6 13.6 13.6s13.6-6.1 13.6-13.6h9.1c7.5 0 13.6 6.1 13.6 13.6V50H9.1z",
    style: {
      fill: "url(#schedule_send-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8 104.5h13.6c5 0 9.1-4.1 9.1-9.1V81.8c0-5-4.1-9.1-9.1-9.1H31.8c-5 0-9.1 4.1-9.1 9.1v13.6c0 5 4.1 9.1 9.1 9.1m0-22.6h13.6v13.6H31.8z",
    style: {
      fill: "url(#schedule_send-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 81.8c0-5-4.1-9.1-9.1-9.1H77.3c-5 0-9.1 4.1-9.1 9.1v13.6c0 5 4.1 9.1 9.1 9.1h13.6c5 0 9.1-4.1 9.1-9.1zm-9.1 13.7H77.3V81.9h13.6z",
    style: {
      fill: "url(#schedule_send-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.7 91.5h.2c2.5 0 4.5-2 4.5-4.5v-5.2c0-5-4.1-9.1-9.1-9.1h-13.6c-5 0-9.1 4.1-9.1 9.1v13.1c0 2.5 2 4.5 4.5 4.5s4.5-2 4.5-4.5V81.8h13.6V87c0 2.5 2 4.5 4.5 4.5",
    style: {
      fill: "url(#schedule_send-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9 150h13.6c5 0 9.1-4.1 9.1-9.1v-13.6c0-5-4.1-9.1-9.1-9.1H31.9c-5 0-9.1 4.1-9.1 9.1v13.6c0 5 4.1 9.1 9.1 9.1m-.1-22.7h13.6v13.6H31.8z",
    style: {
      fill: "url(#schedule_send-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.1 118.9-.1-.1c-1-.4-2.1-.6-3.1-.6H77.3c-5 0-9.1 4.1-9.1 9.1v13.6c0 5 4.1 9.1 9.1 9.1h9.3c2.5 0 4.5-2 4.5-4.5s-2-4.5-4.5-4.5h-9.3v-13.6h13.4c2.3.9 5-.3 5.9-2.6s-.2-4.9-2.5-5.9",
    style: {
      fill: "url(#schedule_send-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 100c-27.6 0-50 22.4-50 50s22.4 50 50 50 50-22.4 50-50-22.4-50-50-50m0 90.9c-22.6 0-40.9-18.3-40.9-40.9s18.3-40.9 40.9-40.9 40.9 18.3 40.9 40.9-18.3 40.9-40.9 40.9",
    style: {
      fill: "url(#schedule_send-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.5 148.1v-20.8c0-2.5-2-4.5-4.5-4.5s-4.5 2-4.5 4.5V150c0 1.2.5 2.4 1.3 3.2l9.1 9.1c1.8 1.7 4.7 1.7 6.4-.1s1.7-4.6 0-6.3z",
    style: {
      fill: "url(#schedule_send-01_svg2__h)"
    }
  }));
};
export default SvgScheduleSend01;